import router from '@/apps/assessment/main'
import ChannelMixin from '@/apps/assessment/mixins/channel-mixin'
import { getBaseInfo } from '@/apps/assessment/model/api'
import clazzRouter from '@/apps/clazz-assessment/main'
import { getCurrentUserInfo, getInitInfo } from '@/apps/index/models/api'
import myAssessmentRouter from '@/apps/myassessment/main'
import { AssessmentAllowSubjects, ClazzAssessmentAllowSubjects } from '@/common/allow-list'
import TopmenuTrackMixin from '@/common/topmenu-track-mixin'
import CmineLogin from '@/components/enroll/CmineLogin.vue'
import FeedBack from '@/components/FeedBack.vue'
import { assessment_subjects, menu, subject_choices } from '@/components/model/topMenu'
import { api_get } from '@/utils/http'
import { msgTip } from '@/utils/urlUtils'
import { Component, Emit, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import { SUBJECT_MAP } from '../../model/common'
import TpAppNameMixins from "@/components/common/mixins/tp-appname";
import { LOGOS } from '@/components/common/mixins/constants';


const myAssessmentRouterChildren = myAssessmentRouter[0].children
const REPORT_DOMAIN = process.env.VUE_APP_REPORT_DOMAIN || 'https://smartreport.test.17zuoye.net/'
const UCENTER_DOMAIN = process.env.VUE_APP_UCENTER_DOMAIN || 'https://ucenter.test.17zuoye.net/'
const assessmentMenu = [
  {
    path: '/assessment/lib',
    name: '校级测评'
  },
  {
    path: '/clazz/lib',
    name: '班级测评'
  }
]
const routerMyAssessment = myAssessmentRouterChildren.map((m) => {
  if (m && m.meta && !m.meta.isClazz) {
    return m
  }
})
const routerMyClazz = myAssessmentRouterChildren.map((m) => {
  if (m && m.meta && m.meta.isClazz) {
    return m
  }
})

@Component({ components: { FeedBack, CmineLogin } })
export default class BasicTop extends Mixins(TopmenuTrackMixin, ChannelMixin, TpAppNameMixins) {
  private get subject_choices() {
    if (location.pathname === '/assessment') {
      return assessment_subjects
    } else {
      return this.subjects || subject_choices
    }
  }
  private get avatar() {
    return this.curUserInfo && this.curUserInfo.avatar
  }
  private get ucenterAddress() {
    return UCENTER_DOMAIN + '/teacher/center/index.vpage'
  }
  private get curModule() {
    return this.$route.meta
  }
  // 登录弹窗
  private get getVisibleEnroll() {
    return this.$store.state.loginModal
  }
  public get curUserInfo() {
    return this.$store.state.user_info
      ? this.$store.state.user_info
      : {
          nickname: '',
          subjects: [],
          avatar: '',
          regions: []
        }
  }
  public get getfeedbackStatus() {
    return this.$store.state.feedbackStatus
  }
  // 本地没有subject的情况下为101，本地有subject情况下为本地subject，重新登录会重置为默认subject
  public get subject() {
    return this.$store.state.subject
  }
  private get logoSource() {
    if (this.tpAppLogo) {
      return this.tpAppLogo
    }
    return LOGOS.default
  }
  @Prop() public showSubject!: boolean
  @Prop() public noPick!: boolean
  @Prop() public nomenu!: boolean
  @Prop() public isClazz!: boolean

  public feedbackModal = false
  public feedbackStatus = false
  // 临时添加登录
  public visibleEnroll = false
  public currentTab = 1
  // 增加可切换的学科
  public down = true
  public subjects: any[] = []
  public uid = ''
  public tiuid = ''
  public modalContext = '您同时用了两个不同账号登录，请刷新页面'
  public visible = false
  public assessmentMenu = assessmentMenu

  private myAssessmentRouterChildren = myAssessmentRouterChildren
  @Watch('getVisibleEnroll')
  public onLoginModalChange(val: any) {
    this.visibleEnroll = val
  }
  // 通过周期性比较tiuid 和 uid 来
  public _set(tiuid, num) {
    const time: any = new Date()
    time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * num)
    window.document.cookie = `tiuid=${tiuid}; path=/; expires=${time.toGMTString()}`
  }
  // get
  public _get() {
    if (document.cookie.length > 0) {
      const cookieArr1 = document.cookie.split(';')
      for (let i in cookieArr1) {
        const cookieArr2 = cookieArr1[i].split('=')
        cookieArr2[0] = cookieArr2[0].replace(/\s+/g, '')
        cookieArr2[1] = cookieArr2[1].replace(/\s+/g, '')
        if (cookieArr2[0] === 'uid') {
          this.uid = cookieArr2[1]
        } else if (cookieArr2[0] === 'tiuid') {
          this.tiuid = cookieArr2[1]
        }
      }
    }
  }
  // 获取userInfo
  public async getUserDetail() {
    try {
      let d: any = await getCurrentUserInfo({})
      let groupLeaderSubject = []
      if (d.success) {
        this.$store.commit('SET_USER_INFO', d.data)
        if (this.isClazz) {
          // 获取默认学科
          let subject = d.data.subjects.map((item) => {
            const nick = SUBJECT_MAP[item[0]]
            return {
              label: item[1],
              value: item[0],
              nick
            }
          })
          let final2: any[] = []
          ClazzAssessmentAllowSubjects.forEach((item: any) => {
            for (let n of subject) {
              if (item && item.value === n.value) {
                final2 = [...final2, n]
              }
            }
          })
          this.$store.commit('SET_CLAZZ_SUPPORT_SUBJECTS', final2)
          if (this.subject && this.subject.value) {
            // 判断学科是否在支持的学科中
            const exist = subject.some((m) => m.value === this.subject.value)
            if (!exist) {
              this.$store.commit('SET_SUBJECT', subject[0])
            }
          } else {
            if (subject && subject.length > 0) {
              this.$store.commit('SET_SUBJECT', subject[0])
            }
          }
        } else {
          groupLeaderSubject = d.data.subjectLeaders || []
          // 获取默认学科
          let subject = d.data.subjects.map((item) => {
            const nick = SUBJECT_MAP[item[0]]
            return {
              label: item[1],
              value: item[0],
              nick
            }
          })
          // result 是该教师所有学科中的学科组长学科
          let result: any[] = []
          groupLeaderSubject.forEach((item: any) => {
            for (let n of subject) {
              if (item.subject === n.nick) {
                n.clazzLevels = item.clazzLevels
                result = [...result, n]
              }
            }
          })
          // 获取学科组长学科，并进行过滤
          let final: any[] = []
          AssessmentAllowSubjects.forEach((item: any) => {
            for (let n of result) {
              if (item && item.value === n.value) {
                final = [...final, n]
              }
            }
          })
          // console.log(final)
          this.$store.commit('SET_SUPPORT_SUBJECTS', final)
          if (this.subject && this.subject.value) {
            // 判断学科是否在支持的学科中
            const exist = final.some((m) => m.value === this.subject.value)
            if (!exist) {
              this.$store.commit('SET_SUBJECT', final[0])
            }
          } else {
            console.log(final)
            if (final && final.length > 0) {
              this.$store.commit('SET_SUBJECT', final[0])
            }
          }
        }
      }
      this.$emit('subject', this.subject.label)
      this.register()
    } catch (e) {
      console.log(e)
    }
  }
  @Watch('getfeedbackStatus', { deep: true })
  public onGetfeedbackStatusChange(val) {
    if (this.feedbackModal) {
      this.onOpenFeedback()
    } else {
      this.feedbackModal = true
      setTimeout(() => {
        this.onOpenFeedback()
        this.feedbackModal = false
      }, 0)
    }
  }
  public onOpenFeedback() {
    this.feedbackStatus = true
    this.trackMenu('我要反馈')
  }
  public onCloseFeedback() {
    this.feedbackStatus = false
  }
  // 点击退出
  public async logoutHandler() {
    let rdata = await api_get('/api/auth/logout', {})
    if (rdata.success) {
      msgTip({
        type: 'success',
        msg: rdata.msg
      })
      // logout logic
      this.$store.commit('SET_USER', { name: null })
      this.$store.commit('SET_USER_INFO', undefined)
      window.location.href = '/'
    } else {
      msgTip({
        type: 'error',
        msg: rdata.error || 'error'
      })
    }
  }

  public mounted() {
    this.getUserDetail()
    this.checkUid()
  }
  public sign() {
    // this.visibleLogin = true
    this.visibleEnroll = true
    this.currentTab = 1
    window['sensors'].track('Head_buttonClick', { buttonName: '登录按钮' })
  }
  public enrollHandler() {
    this.currentTab = 2
  }
  public loginHandler() {
    this.currentTab = 1
  }
  public giveVipPresentHandler() {
    this.$emit('subject', this.subject.label)
    this.onCancel()
    this.checkUid()
    this.register()
  }
  public onCancel() {
    this.visibleEnroll = false
  }
  public checkUid() {
    let tid = setInterval(() => {
      this._get()
      if (this.tiuid && this.uid) {
        if (this.tiuid != this.uid) {
          clearInterval(tid)
          this.$info({
            title: '您同时用了两个不同账号登录，请刷新页面',
            okText: '知道了',
            keyboard: false,
            onOk: () => location.reload(),
            onCancel: () => location.reload()
          })
        }
      }
    }, 2000)
  }
  public handleCancel() {
    this.visible = false
    setTimeout(() => {
      location.reload()
    }, 1000)
  }
  // 控制tab显示
  public allowTab(item) {
    if (
      item.meta.allowSubjects === 'all' ||
      item.meta.allowSubjects.indexOf(this.subject.value) > -1
    ) {
      if (item.meta.section === '校级测评') {
        if (
          this.curUserInfo &&
          this.curUserInfo.subjectLeaders &&
          this.curUserInfo.subjectLeaders.length > 0
        ) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  }
  // 点击注册按钮
  public onRegisterClick(e) {
    window['sensors'].track('Head_buttonClick', { buttonName: '注册按钮' })
    setTimeout(() => {
      window.open('/register')
    }, 200)
    e.preventDefault()
  }
  // 点击我的题库下拉
  public onDropDownMenuClick(item) {
    this.trackMenu(item.meta.label)
    if (item.meta.name === 'report') {
      window.open(REPORT_DOMAIN + '/vox-17xue/groupReport')
    } else {
      setTimeout(() => {
        location.href = item.path
      }, 200)
    }
  }
  private register() {
    let regions = this.curUserInfo.regions
    let _province = regions && regions.length > 0 ? regions[0].name : '未知'
    let _city = regions && regions.length > 1 ? regions[1].name : '未知'
    let _area = regions && regions.length > 2 ? regions[2].name : '未知'
    const env = process.env.VUE_APP_MODE || 'development'
    const channel = this.SAchannel

    setTimeout(() => {
      window['sensors'].registerPage({
        platform: 'Web',
        product: '内容库',
        subject: String(this.subject.value) || undefined,
        _province,
        _city,
        _area,
        env,
        channel
      })
    }, 50)
  }
  private getPopupContainer() {
    return document.getElementById('dropDownContainer')
  }
  private openNewTab() {
    const section = this.curModule && this.curModule.section
    if (section === '班级测评') {
      window.open('/clazz/lib')
    } else {
      window.open('/assessment/lib')
    }
  }
  // 点击校级测评的下拉菜单
  private onAssessmentMenuClick(item) {
    const clazzRouterList = [...clazzRouter, ...routerMyClazz]
    const routerList = [...router, ...routerMyAssessment]
    // 建立校级测评和班级测评映射，同名，如果没有map对应名字的，直接跳转到对应模块的首页即可。
    const mapName = this.$route.meta.map || ''
    const home = item.path
    const module = item.name
    // 新页面打开
    console.log(mapName)
    if (module === '班级测评') {
      const result = clazzRouterList.find((n: any) => {
        if (n && n.meta && n.meta.map) {
          return n.meta.map === mapName
        }
      })
      if (result && result.path) {
        window.open(result.path)
      } else {
        window.open(home)
      }
    }
    if (module === '校级测评') {
      const result = routerList.find((n: any) => {
        if (n && n.meta && n.meta.map) {
          return n.meta.map === mapName
        }
      })
      if (result && result.path) {
        window.open(result.path)
      } else {
        window.open(home)
      }
    }
  }
}
